import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import BottomNav from '../BottomNav';
import FavoriteButton from './FavoriteButton';
import theme from '../theme';

function Preferiti({ session }) {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchFavorites(); }, []);

  const fetchFavorites = async () => {
    setLoading(true);
    const { data } = await supabase
      .from('favorites')
      .select('job_id, jobs(*)')
      .eq('user_id', session.user.id)
      .order('created_at', { ascending: false });
    if (data) setFavorites(data.filter(f => f.jobs));
    setLoading(false);
  };

  const removeFavorite = async (jobId) => {
    setFavorites(prev => prev.filter(f => f.job_id !== jobId));
    await supabase.from('favorites').delete().eq('user_id', session.user.id).eq('job_id', jobId);
  };

  return (
    <div style={{ maxWidth: theme.layout.maxWidth, margin: '0 auto', fontFamily: theme.font.family }}>
      <div style={{ background: theme.colors.primary, padding: '16px 20px', display: 'flex', alignItems: 'center', gap: theme.spacing.md }}>
        <button onClick={() => navigate('/profilo')} style={{ background: 'none', border: 'none', color: theme.colors.white, fontSize: 22, cursor: 'pointer', padding: 0 }}>←</button>
        <h2 style={{ margin: 0, color: theme.colors.white, fontSize: theme.font.size.xxl }}>❤️ Annunci preferiti</h2>
      </div>

      <div style={{ padding: theme.spacing.xl, paddingBottom: 80 }}>
        {loading && <p style={{ textAlign: 'center', color: theme.colors.textMuted }}>Caricamento...</p>}

        {!loading && favorites.length === 0 && (
          <div style={{ textAlign: 'center', marginTop: 60 }}>
            <div style={{ fontSize: 48, marginBottom: theme.spacing.lg }}>💔</div>
            <p style={{ color: theme.colors.textMuted, fontSize: theme.font.size.md }}>Non hai ancora salvato nessun annuncio.</p>
            <p style={{ color: '#bbb', fontSize: theme.font.size.sm }}>Tocca il cuoricino su un annuncio per salvarlo qui.</p>
          </div>
        )}

        {favorites.map(fav => {
          const job = fav.jobs;
          return (
            <div key={fav.job_id} onClick={() => navigate(`/job/${job.id}`)}
              style={{
                borderRadius: theme.radius.lg, marginBottom: theme.spacing.md, cursor: 'pointer',
                position: 'relative', background: theme.colors.white, overflow: 'hidden',
                boxShadow: theme.shadow.card, border: `1px solid ${theme.colors.border}`,
              }}>
              <div style={{ position: 'absolute', top: 10, right: 10, zIndex: 2 }}>
                <FavoriteButton isFavorite={true} onToggle={() => removeFavorite(job.id)} />
              </div>
              <div style={{ padding: theme.spacing.lg }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: theme.spacing.sm, paddingRight: 40 }}>
                  <span style={{ fontWeight: 600, fontSize: theme.font.size.md }}>{job.title}</span>
                  <span style={{ color: theme.colors.primary, fontWeight: 600 }}>{job.price}</span>
                </div>
                <div style={{ fontSize: theme.font.size.base, color: theme.colors.textSecondary, display: 'flex', gap: theme.spacing.md, flexWrap: 'wrap', alignItems: 'center' }}>
                  <span style={{ background: theme.colors.primaryLight, color: theme.colors.primary, padding: '2px 8px', borderRadius: theme.radius.md, fontSize: theme.font.size.sm }}>{job.category}</span>
                  {job.city && <span style={{ color: theme.colors.textMuted, fontSize: theme.font.size.sm }}>📍 {job.city}</span>}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <BottomNav />
    </div>
  );
}

export default Preferiti;